import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  Style: {
    height: 40,
    "& .MuiSelect-select": {
      zIndex: "99",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
    },
    "& .MuiSelect-icon": {
      zIndex: "99",
    },
    "& .MuiButtonBase-root-MuiMenuItem-root": {
      WebkitAlignItems: "normal",
      alignItems: "normal",
      backgroundColor: "red",
    },
  },
});
function SelectDropdown(props) {
  const { styles, option, label, opt_list, end_point, key_name, disab } = props;
  const classes = useStyles();
  const [val, setval] = useState(0);
  useEffect(() => {
    if (props[key_name] !== undefined) {
      setval(props[key_name]);
    }
  }, [props[key_name]]);
  return (
    <div>
      <label className="label">{label}</label>
      <FormControl className={styles}>
        <Select
          value={val}
          //         onChange={onChange}
          name={key_name}
          defaultValue={0}
          displayEmpty
          disabled={disab}
          inputProps={{ "aria-label": "Without label" }}
          className={styles === "select-custom" ? styles : classes.Style}
        >
          <MenuItem value={0}>Select...</MenuItem>

          {(option ? option : opt_list?.[end_point]).map((a, i) => (
            <MenuItem value={a.value} key={i}>
              <span>
                <span
                  style={{ backgroundColor: a.icon }}
                  className="blue me-2"
                ></span>
                &nbsp;
                {a.label}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default React.memo(SelectDropdown);
